import type Transaction from '~/types/Transaction';

import { ActionKeys } from '~/actions/constants';
import { type ActionTypes } from '~/actions/index';

export type TransactionsState = {
  readonly data: { [transactionId: string]: Readonly<Transaction> };
  readonly fetchingTransactions: boolean;
  readonly firstSuccessfulTransactionObjectId: string | undefined;
  readonly successfulTransactionsCount: number;
};

export const initialState: TransactionsState = {
  data: {},
  fetchingTransactions: false,
  firstSuccessfulTransactionObjectId: undefined,
  // These are used for tracking purposes
  successfulTransactionsCount: 0,
};

const reducer = (
  state: TransactionsState = initialState,
  action: ActionTypes,
): TransactionsState => {
  switch (action.type) {
    case ActionKeys.FETCH_TRANSACTION:
      return {
        ...state,
        fetchingTransactions: true,
      };
    case ActionKeys.FETCH_TRANSACTION_SUCCESS: {
      return {
        ...state,
        data: {
          ...state.data,
          [action.payload.transaction.objectId]: action.payload.transaction,
        },
        fetchingTransactions: false,
      };
    }
    case ActionKeys.FETCH_TRANSACTION_ERROR:
      return {
        ...state,
        fetchingTransactions: false,
      };
    case ActionKeys.UPDATE_SUCCESSFUL_TRANSACTIONS_COUNT:
      return {
        ...state,
        successfulTransactionsCount: action.payload.count,
      };
    case ActionKeys.UPDATE_FIRST_SUCCESSFUL_TRANSACTION_OBJECT_ID:
      return {
        ...state,
        firstSuccessfulTransactionObjectId: action.payload.objectId,
      };
    default:
      return state;
  }
};

export default reducer;
